import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgProfile = function SvgProfile(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 25 24",
    size: size
  }, props), React.createElement("g", {
    fill: "currentColor",
    clipPath: "url(#profile_svg__clip0)"
  }, React.createElement("path", {
    d: "M11.975 11.953a3.984 3.984 0 100-7.969 3.984 3.984 0 000 7.97z"
  }), React.createElement("path", {
    d: "M11.975 2.016c5.484 0 9.984 4.453 9.984 9.984 0 5.484-4.453 9.984-9.984 9.984s-9.937-4.547-9.937-10.03c0-5.485 4.453-9.938 9.937-9.938zm0-2.016A11.943 11.943 0 00.022 11.953c0 6.61 5.344 11.953 11.953 11.953 6.61 0 11.953-5.343 11.953-11.953C23.928 5.343 18.584 0 11.975 0z"
  }), React.createElement("path", {
    d: "M11.975 13.969a7.99 7.99 0 00-7.734 6l7.734 3.375 7.734-3.422a8.002 8.002 0 00-7.734-5.953z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "profile_svg__clip0"
  }, React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z",
    transform: "translate(.022)"
  }))));
};

export default SvgProfile;